import { TaskStatusEnum } from '@viapeople/api/src/modules/tasks/tasks.types'

export const resolveTaskColor = (taskStatus: string) => {
	switch (taskStatus) {
		case TaskStatusEnum.COMPLETED:
			return 'green'
		case TaskStatusEnum.NOT_STARTED:
			return 'yellow'
		case TaskStatusEnum.REJECTED:
			return 'red'
		default:
			return 'default'
	}
}

export const resolveTaskLabel = (taskStatus: string): string => {
	switch (taskStatus) {
		case TaskStatusEnum.NOT_STARTED:
			return 'Not Started'
		case TaskStatusEnum.IN_PROGRESS:
			return 'In Progress'
		case TaskStatusEnum.COMPLETED:
			return 'Completed'
		case TaskStatusEnum.DECLINED:
			return 'Declined'
		case TaskStatusEnum.REJECTED:
			return 'Rejected'
		default:
			return toSentenceCase(taskStatus)
	}
}

export const toSentenceCase = (str: string): string => {
	if (!str) return str
	return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
}

export const formatStepName = (stepName: string): string => {
	if (!stepName) return stepName
	return stepName
		.split('_')
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
		.join(' ')
}
